"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var paymentFrequencyStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var typography = _a.typography, palette = _a.palette, breakpoints = _a.breakpoints;
    return ({
        priceElement: (_b = {
                fontFamily: typography.fontFamily2,
                color: palette.text.primary,
                fontSize: typography.fontXL
            },
            _b[breakpoints.down('xs')] = {
                fontSize: typography.fontMD,
            },
            _b),
        tooltipCloseIcon: {
            position: 'absolute',
            right: 10,
            top: 10,
            color: palette.primary.main,
            fontSize: typography.fontXL,
            cursor: 'pointer',
        },
        paymentFrequencyContainer: {
            display: 'flex',
            alignItems: 'center',
        },
        disclaimer: {
            '& sup': {
                verticalAlign: 'super',
                fontSize: typography.fontXS,
            },
        },
    });
}, { name: 'GqlSummary_PaymentFrequency' });
exports.default = paymentFrequencyStyles;
